import { Component, OnInit, Inject } from "@angular/core";
import { EmployeeBonus } from "../../models/OnboardingHRDetail";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { UserService } from "../../service/user.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { EmployeeService } from "../../service/employee.service";

@Component({
  selector: "app-compensation-dialog",
  templateUrl: "./compensation-dialog.component.html",
  styleUrls: ["./compensation-dialog.component.css"],
})
export class CompensationDialogComponent implements OnInit {
  title: string;
  message: any;
  bonus: EmployeeBonus;
  error: any;
  empCode: number;
  CompensationForm: FormGroup;
  bonusList: EmployeeBonus[];
  visabool: Boolean = false;
  constructor(
    private toastr: ToastrService,
    private userService: UserService,
    public dialogRef: MatDialogRef<CompensationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BonusDialog,
    private _service: EmployeeService,
    private formBuilder: FormBuilder
  ) {
    dialogRef.disableClose = true;
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {
    this.bonus = new EmployeeBonus();
    this.getBonusTypes();
    this.empCode = this.userService.getEmpCode();
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    this.CompensationForm = this.formBuilder.group({
      Name: [
        "",
        [Validators.required, Validators.pattern(nonWhitespaceRegExp)],
      ],
    });
  }

  getBonusTypes() {
    this._service.getEmpBonus().subscribe((data: any) => {
      this.bonusList = data;
    });
  }

  get f() {
    return this.CompensationForm.controls;
  }

  onConfirm(): void {
    if (!this.CompensationForm.invalid) {
      this.bonus.ModifiedBy = this.empCode.toString();
      this.bonusList.forEach((item) => {
        if (item.Name.toLowerCase() == this.bonus.Name.toLowerCase()) {
          this.visabool = true;
        }
      });
      if (this.visabool == false) {
        this._service
          .saveEmpBonus({
            ...this.bonus,
            IsCTC: this.message === "ctc" ? true : false,
          })
          .subscribe(
            (data) => {
              this.dialogRef.close(this.bonus);
            },
            (error) => (this.error = error)
          );
      } else {
        this.toastr.warning("Same name exists");
        this.bonus.Name = null;
        this.visabool = false;
      }
    } else {
      return;
    }
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

export class BonusDialog {
  constructor(public title: string, public message: any) {}
}
